export const setInvoices = (state, payload) => {
  state.invoices = payload
}
export const setInvoice = (state, payload) => {
  state.invoice = payload
}
export const setInvoiceLines = (state, payload) => {
  state.invoiceLines = payload
}
export const setInvoiceDeletedItems = (state, payload) => {
  state.invoiceDeletedItems = payload
}
export const setInvoiceAccountEntries = (state, payload) => {
  state.invoiceAccountEntries = payload
}
export const setWorkingInvoice = (state, payload) => {
  state.workingInvoice = payload
  state.workingInvoice.commercialPermit = Boolean(state.workingInvoice.commercialPermitID)
}
export const setPayments = (state, payload) => {
  state.payments = payload
}
export const clearStalePayments = (state, payload) => {
  state.payments = []
}
